var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticStyle:{"margin-left":"10px"},attrs:{"type":"text","icon":"el-icon-delete","disabled":_vm.isBusy,"loading":_vm.isBusy},on:{"click":_vm.onDelete}})
}
var staticRenderFns = []

export { render, staticRenderFns }